import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-inactive-admin-deleted-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './inactive-admin-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class InactiveAdminDeletedTemplateComponent {
  public readonly data = input.required<WrappedValue<InactiveAdminDeletedTemplateData>>();
}

export type InactiveAdminDeletedTemplateData = {
  title: string;
  p1: string;
  button_text: string;
  button_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const InactiveAdminDeletedTemplateMocks: InactiveAdminDeletedTemplateData[] = [
  {
    title: 'Your company account [Company_name_here] has been deleted',
    p1: 'We deleted your company account because your subscription has been inactive for over 6 months. If you want to keep using Recruitee, please create a new account.',
    button_text: 'See plans',
    button_link: 'http://recruitee.com',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
